import Services from "@/components/sections/Services";
import { useSite } from "@/contexts/SiteContext";
import SectionStyles from "@/components/sections/SectionStyles";
import SectionCta from "@/components/SectionCta";

// Fallback dacă secțiunea CMS lipsește (ex. înainte de seed). În mod normal
// content.items vine din seed → editarea inline pe items.N funcționează.
// Cele 4 ședințe 1:1 din documentele de brand — nu inventa servicii noi aici.
const FALLBACK_ITEMS = [
  { title: "Eliberare: Amintire, Traumă, Iertare, Vină, Regret", desc: "Pentru momentele în care o singură amintire, un regret, o traumă sau o vină nerezolvată îți apasă sufletul. Mergem direct acolo — cu blândețe, claritate și putere." },
  { title: "Ședință de Eliberare Mentală și Emoțională", desc: "Gânduri repetitive, convingeri limitative, frici profunde, vină, rușine, furie, tristețe, neiertare — aduse la lumină, înțelese și eliberate, într-un spațiu sigur și blând." },
  { title: "Eliberare Mentală, Emoțională + Curățarea Chakrelor", desc: "Extinde procesul de eliberare cu curățarea chakrelor și deblocarea energiilor stagnante — pentru cei care simt că doar înțelegerea nu mai este suficientă." },
  { title: "Ședință de Transformare Completă", desc: "Mental, emoțional, energetic și spiritual — eliberăm amintiri dureroase, traume, vină și rușine, curățăm influențele negative și lucrăm pentru recuperarea părților de suflet. Despre întregire." },
];

export default function ServicesPage() {
  const { sectionContent } = useSite();
  const c = sectionContent("services_page") || {};
  const cServices = sectionContent("services") || {};
  const items = Array.isArray(c.items) && c.items.length ? c.items : FALLBACK_ITEMS;
  return (
    <div data-testid="services-page">
      <div data-section-key="services" data-section-title="Servicii de transformare interioară">
        <SectionStyles scopeKey="services" content={cServices} />
        <Services />
      </div>
      <div data-section-key="services_page" data-section-title="Servicii — Lista extinsă">
        <SectionStyles scopeKey="services_page" content={c} />
        <section className="py-24" style={{ background: "var(--ct-bg)" }}>
          <div className="max-w-7xl mx-auto px-5 lg:px-8">
            <div className="max-w-3xl mb-12">
              <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Lista extinsă"}</span>
              <h2 data-el="title" data-field="title" className="font-serif text-4xl sm:text-5xl mt-4 leading-tight">{c.title || "Toate formele de lucru"}</h2>
              <p data-el="subtitle" data-field="intro" className="text-base leading-relaxed mt-3" style={{ color: "var(--ct-text-muted)" }}>
                {c.intro || "Alegerea formei se face împreună, după o discuție inițială. Prețurile se discută individual, în funcție de nevoia ta și pachetul ales."}
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
              {items.map((s, i) => (
                <div key={i} className="card-premium p-7" data-testid={`extended-service-${i}`}>
                  <h3 data-el="item_title" data-field={`items.${i}.title`} className="font-serif text-2xl mb-3">{s.title}</h3>
                  <p data-el="item_body" data-field={`items.${i}.desc`} className="text-sm leading-relaxed" style={{ color: "var(--ct-text-muted)" }}>{s.desc}</p>
                  <SectionCta
                    content={s}
                    prefix="cta"
                    fieldPrefix={`items.${i}.`}
                    fallbackText="Programează"
                    fallbackLink="/programare"
                    className="mt-5 inline-flex items-center gap-2 text-sm hover:gap-3 transition-all text-[var(--ct-gold)]"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
